import React, { useEffect, useState } from 'react'
import Navbar from './shared/Navbar'
import Card from './shared/Card'
import KitchenBanner from './shared/KitchenBanner';
import { KitchenService } from '../../services/KitchenService'
import { useLocalStorage } from '../../auth/useLocalStorage'
import { usePusher } from '../../context/pusherContext'
import './index.css'
import { type IEvent, type Orders } from '../../common/interfaces'
import { ListModal } from './shared/ListModal'
import NotificationSound from "./NotificationSound";
import { Nav } from 'react-bootstrap';

const Index = () => {
  const pusher = usePusher()
  const [user] = useLocalStorage('user', null)
  const [orders, setOrders] = useState<Orders[]>([])
  const [display, setDisplay] = useState(false)
  const [update, setUpdate] = useState(1)
  // const [notificationMessage, setNotificationMessage] = useState<string | null>(null);
  // const [notifications, setNotifications] = useState<{ id: number; message: string }[]>([]);
  const [notifications, setNotifications] = useState<{ id: string; message: string; type: string, order_id: number }[]>([]);


  const [
    schedules, setSchedules
  ] = useState(false)
  const [activeTab, setActiveTab] = useState('active')
  const displayStatus = ['Pending', 'Cooking', 'Schedule', 'Shipped']
  const openList = (schedules?:boolean) => {
    setSchedules(schedules ?? false)
    setUpdate(update + 1)
    setDisplay(true)
  }
  const [allOrders, setAllOrders] = useState<Orders[]>([])

  // Establecer el título de la pestaña para la pantalla de cocina
  useEffect(() => {
    document.title = "Cocina - La Bifería";
  }, []);

  const getOrders = async (maxRetries: number = 1) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const res = await KitchenService.show(user.kitchen_id as string);

        if (res.success && res.object?.orders) {
          // El backend ya filtra las órdenes correctamente con display_type=kitchen
          // No necesitamos filtrar aquí, usamos todas las órdenes que vienen del API
          const kitchenOrders = res.object.orders;

          // Guardar todos los pedidos de cocina
          setAllOrders(kitchenOrders);

          // Filtrar según la pestaña activa usando kitchen_status
          if (activeTab === 'active') {
            const activeOrders = kitchenOrders.filter(order => {
              const kitchenStatus = order.kitchen_status || order.status;
              // Excluir pedidos que ya están entregados en cocina
              return displayStatus.includes(kitchenStatus) && kitchenStatus !== 'Shipped';
            });
            setOrders(activeOrders);
          } else if (activeTab === 'done') {
            const doneOrders = kitchenOrders.filter(order => {
              const kitchenStatus = order.kitchen_status || order.status;
              // Excluir pedidos que ya están entregados en cocina
              // Excluir pedidos a domicilio que están Done (se entregan desde caja)
              return kitchenStatus === 'Done' && order.shipped_type !== 'shipped';
            });
            setOrders(doneOrders);
          }

          setUpdate(prev => prev + 1);
          return; // Salir si fue exitoso
        }

        // Si no hay órdenes y no es el último intento, esperar antes del siguiente
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      } catch (error) {
        console.error(`Error fetching kitchen orders (attempt ${attempt}):`, error);
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }
    }
  }

  const handleApprove = (notification: any) => {

    setNotifications((prev) => prev.filter((n) => n.id !== notification.id));


    KitchenService.setAppOrderStatus(notification.order_id, {
      status: 'accepted'
    });

    console.log('Order approved:', notification.order_id);

  };

  const handleReject = (notification: any) => {

    setNotifications((prev) => prev.filter((n) => n.id !== notification.id));


    KitchenService.setAppOrderStatus(notification.order_id, {
      status: 'rejected'
    });

    console.log('Order rejected:', notification.order_id);
  };

  const generateID = () => {

    return Date.now().toString() + Math.floor(Math.random() * 1000);
  }

  const checkIfOrderHasKitchenProducts = async (orderId: number, maxRetries: number = 3): Promise<boolean> => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        // Hacer una consulta fresca para obtener el pedido específico
        const res = await KitchenService.show(user.kitchen_id as string);
        if (res.success && res.object?.orders) {
          const order = res.object.orders.find(o => o.id === orderId);
          if (order) {
            // El backend ya filtra con display_type=kitchen, si la orden está aquí, es porque tiene productos de cocina
            return true;
          }
        }

        // Si no encontramos el pedido y no es el último intento, esperar antes del siguiente
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      } catch (error) {
        console.error(`Error checking order products (attempt ${attempt}):`, error);
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }
    }
    return false;
  };

  useEffect(() => {
    getOrders()
    const channel = pusher.subscribe('kitchen-channel')

    // Escuchar nuevos pedidos y actualizaciones
    channel.bind('new-order', async (order: IEvent) => {
      if (order.success && order.object && order.object.kitchen_id === user.kitchen_id) {
        if (order.object.type == 'ORDER_APPROVAL') {
          // Las notificaciones de aprobación deben aparecer en ambas pantallas
          setNotifications((prev) => [
            ...prev,
            { id: generateID(), message: order.object.message, type: order.object.type, order_id: order.object.order_id}
          ]);
        } else if (order.object.type == 'ORDER_STATUS_UPDATE') {
          // Actualización de estado de pedido - solo refrescar sin notificación
          console.log('Kitchen screen: Order status update received, refreshing orders...', order.object);
          await getOrders();
        } else {
          // Usar reintentos para actualizar la lista de pedidos y mostrar notificación
          setTimeout(async () => {
            // Actualizar la lista con reintentos
            await getOrders(3);

            // Verificar si el pedido tiene productos de cocina
            const hasKitchenProducts = await checkIfOrderHasKitchenProducts(order.object.order_id);
            if (hasKitchenProducts) {
              setNotifications((prev) => [
                ...prev,
                { id: generateID(), message: "<h1>Se ha recibido un nuevo Pedido</h1>", type: 'MESSAGE', order_id: order.object.order_id}
              ]);
            }
          }, 1000);
        }
      }
    });

    // Escuchar cambios de estado de pedidos
    channel.bind('order-status-changed', async (data: any) => {
      if (data.success && data.object && data.object.kitchen_id === user.kitchen_id) {
        if (data.object.type === 'PAYMENT_STATUS_UPDATE') {
          console.log('Kitchen screen: Payment status updated, refreshing orders...', data.object);
          // Actualizar inmediatamente cuando se actualiza el estado de pago
          await getOrders();
        } else {
          console.log('Kitchen screen: Order status changed, refreshing orders...', data.object);
          await getOrders();
        }
      }
    });

    return () => {
      channel.unbind('new-order');
      channel.unbind('order-status-changed');
    };
  }, [pusher, user.kitchen_id])

  // Escuchar cambios de estado desde otras pestañas
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'order-status-changed' && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          console.log('Kitchen screen: Order status changed from another tab, refreshing orders...', data);
          // Actualizar la lista de pedidos cuando hay cambios desde otras pestañas
          getOrders();
        } catch (error) {
          console.error('Error parsing order status change data:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [])



  // Efecto para actualizar los pedidos cuando cambia la pestaña activa
  useEffect(() => {
    if (allOrders.length > 0) {
      if (activeTab === 'active') {
        const filteredOrders = allOrders.filter(order => {
          const kitchenStatus = order.kitchen_status || order.status;
          // Excluir pedidos que ya están entregados en cocina
          return displayStatus.includes(kitchenStatus) && kitchenStatus !== 'Shipped';
        });
        setOrders(filteredOrders);
      } else if (activeTab === 'done') {
        const filteredOrders = allOrders.filter(order => {
          const kitchenStatus = order.kitchen_status || order.status;
          // Excluir pedidos que ya están entregados en cocina
          // Excluir pedidos a domicilio que están Done (se entregan desde caja)
          return kitchenStatus === 'Done' && order.shipped_type !== 'shipped';
        });
        setOrders(filteredOrders);
      }
    }
  }, [activeTab, allOrders])
  return (
    <>
      <Navbar openList={openList}/>
      <ListModal display={display} setDisplay={setDisplay} key={update} schedules={schedules}/>

      {notifications.map((notification, index) => (
        <NotificationSound
          key={notification.id}
          id={notification.id}
          message={notification.message}
          type={notification.type}
          count={index + 1}
          total={notifications.length}
          onClose={() => setNotifications((prev) => prev.filter((n) => n.id !== notification.id))}
          onApprove={() => handleApprove(notification)}
          onReject={() => handleReject(notification)}
        />
      ))}


      <KitchenBanner
        orders={activeTab === 'active' ? orders : allOrders.filter(order => {
          const kitchenStatus = order.kitchen_status || order.status;
          return displayStatus.includes(kitchenStatus);
        })}
        totalOrders={orders.length}
      />

      <div className="container-fluid">
        <Nav
          variant="tabs"
          className="mb-3"
          activeKey={activeTab}
          style={{
            borderBottom: '2px solid #6c757d',
            paddingBottom: '0px',
            marginBottom: '20px'
          }}
          onSelect={(k) => {
            if (k) {
              setActiveTab(k)
              // Actualizar los pedidos mostrados según la pestaña seleccionada
              if (k === 'active') {
                setOrders(allOrders.filter(order => {
                  const kitchenStatus = order.kitchen_status || order.status;
                  // Excluir pedidos que ya están entregados en cocina
                  return displayStatus.includes(kitchenStatus) && kitchenStatus !== 'Shipped';
                }))
              } else if (k === 'done') {
                setOrders(allOrders.filter(order => {
                  const kitchenStatus = order.kitchen_status || order.status;
                  // Excluir pedidos que ya están entregados en cocina
                  // Excluir pedidos a domicilio que están Done (se entregan desde caja)
                  return kitchenStatus === 'Done' && order.shipped_type !== 'shipped';
                }))
              }
            }
          }}
        >
          <Nav.Item>
            <Nav.Link
              eventKey="active"
              className={activeTab === 'active' ? 'bg-primary text-white' : 'text-white'}
              style={{
                borderRadius: '8px 8px 0 0',
                fontWeight: 'bold',
                fontSize: '16px',
                padding: '10px 20px',
                margin: '0 5px'
              }}
            >
              Pedidos Activos <span className="badge bg-light text-primary ms-2" style={{ fontSize: '14px' }}>
                {allOrders.filter(order => {
                  const kitchenStatus = order.kitchen_status || order.status;
                  // Excluir pedidos que ya están entregados en cocina
                  return displayStatus.includes(kitchenStatus) && kitchenStatus !== 'Shipped';
                }).length}
              </span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="done"
              className={activeTab === 'done' ? 'bg-success text-white' : 'text-white'}
              style={{
                borderRadius: '8px 8px 0 0',
                fontWeight: 'bold',
                fontSize: '16px',
                padding: '10px 20px',
                margin: '0 5px'
              }}
            >
              Pedidos Terminados <span className="badge bg-light text-success ms-2" style={{ fontSize: '14px' }}>
                {allOrders.filter(order => {
                  const kitchenStatus = order.kitchen_status || order.status;
                  // Excluir pedidos a domicilio que están Done (se entregan desde caja)
                  return kitchenStatus === 'Done' && order.shipped_type !== 'shipped';
                }).length}
              </span>
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="row g-3">
          {
            orders.map((item) => (
              <div key={item.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
                <Card {...item} className="w-100" updateCallback={getOrders}/>
              </div>
            ))
          }
          {
            orders.length === 0 && (
              <div className="col-12">
                <h3 style={{ textAlign: 'center', color: 'white' }}>
                  {activeTab === 'active' ? 'No hay pedidos pendientes' : 'No hay pedidos terminados'}
                </h3>
              </div>
            )
          }
        </div>
      </div>
    </>
  )
}

export default Index
